export default __webpack_public_path__ + "static/media/gradient.8e890011.png";